import React from 'react'
import { makeStyles, Tooltip } from '@paintscout/ui'
import type { TooltipProps, MuiTheme as Theme, StyleClasses } from '@paintscout/ui'

const useStyles = makeStyles<Theme, PresEditorTooltipProps>(
  (theme) => ({
    tooltip: {
      ...theme.typography.subtitle2,
      color: theme.palette.common.white,
      fontSize: '0.8rem'
    }
  }),
  { name: 'PresEditorTooltip' }
)

export interface PresEditorTooltipProps extends TooltipProps {
  classes?: StyleClasses<typeof useStyles>
}

function PresEditorTooltip(props: PresEditorTooltipProps) {
  const classes = useStyles(props)
  const { children, ...rest } = props

  const [open, setOpen] = React.useState(false)

  // Callers set the disable*Listener props while their popup menu is open, but MUI schedules
  // opens on an enterDelay timer, so one can still fire after the listeners are disabled —
  // suppress those late opens too, and close anything already showing.
  const suppressed = Boolean(rest.disableHoverListener || rest.disableFocusListener || rest.disableTouchListener)
  const suppressedRef = React.useRef(suppressed)
  suppressedRef.current = suppressed

  React.useEffect(() => {
    if (suppressed) setOpen(false)
  }, [suppressed])

  const handleClose = () => {
    setOpen(false)
  }

  const handleOpen = (ev) => {
    if (suppressedRef.current) {
      return null
    }
    if (ev.target.className.includes && ev.target.className.includes('MuiPopover')) {
      return null
    } else setOpen(true)
  }

  return (
    <Tooltip
      hideIcon
      enterDelay={800}
      enterNextDelay={400}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
      placement={'bottom'}
      {...rest}
      classes={{ tooltip: classes.tooltip, ...rest.classes }}
    >
      <div onMouseDown={handleClose}>{children}</div>
    </Tooltip>
  )
}

export default PresEditorTooltip
